<div class="org-list-container">
    <div class="col-8">
        <label>Organization</label>
        <ValidatedTextField [label]="txtOrgSelected"
                            [text]="orgSelected?.orgName"
                            id="txtOrgSelected"
                            [disabled]="'true'">
        </ValidatedTextField>
    </div>
    <br />
    <div [hidden]="hideBrowseView">
        <div class="col-2">
            <a (click)="onToggle()" *ngIf="!hideBrowseView">
                <span class="browseicon" *ngIf="!tabToggle"></span>
                <span class="closeicon" *ngIf="tabToggle"></span>
            </a>
        </div>
        <div [hidden]="!tabToggle">
            <ep-tabs>
                <ep-tab tabTitle="{{labelName}}">
                    <div class="org-dropdown-content">
                        <ep-tabs>
                            <ep-tab tabTitle="Browse">
                                <org-list-container-new #orgListContainer
                                                        [rootOrgId]="rootOrgId"
                                                        (orgAdded)="onOrgAdd($event)"
                                                        (orgTreeNodeAdded)="onSearchResultsChanged($event)"></org-list-container-new>
                            </ep-tab>
                            <ep-tab tabTitle="Search">
                                <org-search-new #orgSearch
                                                (searchResultChanged)="onSearchResultsChanged($event)"
                                                (orgAdded)="onOrgAdd($event)"
                                                [resetSearch]="resetSearch"></org-search-new>
                            </ep-tab>
                        </ep-tabs>

                    </div>
                </ep-tab>
            </ep-tabs>
        </div>

    </div>
    <br />
</div>